<div id="credit-card-add-wrapper" class="credit-card-add-wrapper">
  @if (stripeNotLoaded()) {
    <iris-banner
      [bannerType]="irisBannerType.WARNING"
      [headerText]="'Unable to load payment provider'"
      [showDismiss]="false"
    >
      We're having trouble communicating with Stripe for credit card handling. Please refresh your browser to continue.
    </iris-banner>
  }

  @if (cardErrorMessage()) {
    <iris-banner
      [bannerType]="irisBannerType.WARNING"
      [headerText]="cardErrorMessage().title"
      [showDismiss]="false"
      data-test="banner-title"
    >
    </iris-banner>
  }

  <form
    #creditCardForm
    id="credit-card-add-form"
    [formGroup]="ccForm"
    method="post"
    class="stripe-card-form"
  >    
    <div class="stripe-field-group">
      <label
        for="stripe-card-number-element"
        class="stripe-field-label"
        data-test="payment-add-card-card-number-header-text"
      >
        Card Number *
      </label>
      <div
        id="stripe-card-number-element"
        class="stripe-field-input"
        aria-required="true"
      ></div>
    </div>

    <div class="stripe-field-row stripe-field-group">
      <div class="stripe-field-input-container exp-field">
        <label
          for="stripe-card-exp-element"
          class="stripe-field-label"
          data-test="payment-add-card-expiration-header-text"
        >
          Expiration *
        </label>
        <div
          id="stripe-card-exp-element"
          class="stripe-field-input"
          aria-required="true"
        ></div>
      </div>
      <div class="stripe-field-input-container">
        <label
          for="stripe-card-cvc-element"
          class="stripe-field-label"
          data-test="payment-add-card-cvv-header-text"
        >
          CVV *
        </label>
        <div
          id="stripe-card-cvc-element"
          class="stripe-field-input"
          aria-required="true"
        ></div>
      </div>
    </div>

    @if (!useInline()) {
      <iris-form-field
        label="Card Nickname"
        [showOptionalTag]="false"
        class="card-nickname-input"
        data-test="payment-add-card-card-nickname-header-text"
      >
        <iris-text-input
          name="nickname"
          formControlName="nickname"
          data-test="field-card-nickname"
        ></iris-text-input>
      </iris-form-field>
    }

    @if (showFinancialAgreement()) {
      <form
        [formGroup]="financialPolicyForm"
        class="financial-responsibility-agreement"
      >
        <iris-checkbox
          formControlName="acceptedFinancialPolicy"
          data-test="payment-authorization-checkbox-text"
        >
          I agree to the
          <a
            class="iris-link-responsive"
            [href]="financialResponsibilityAgreement"
            target="_blank"
          >Financial Responsibility Agreement</a>,
          and authorize SonderMind to charge the payment card on file in accordance with those terms.
        </iris-checkbox>
      </form>
    }

    @if (!useInline()) {
      <iris-button-container>
        @if (submitting()) {
          <iris-spinner size="sm"></iris-spinner>
        } @else {
          <iris-button
            [type]="IrisButtonTypes.PRIMARY"
            [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
            id="pendo-credit-card-save"
            data-test="button-save"
            [disabled]="submitting() || !formValid()"
          >
            Save
          </iris-button>
        }
      </iris-button-container>
    }
  </form>

</div>
